export class ChangeObject<T> {
    current: T;
    previous: T;

    constructor(current: T, previous: T) {
        this.current = current;
        this.previous = previous;
    }
}
